import { type TextEffectPreset } from '@meitu/saas-editor-core/es/layers/text-layer';

type TextEffectPresetEnhance = TextEffectPreset & {
    isVip?: boolean;
};

export const getEffectPresets = (fontSize: number) => {
    const ratio = fontSize / 170;

    const presets: TextEffectPresetEnhance[] = [
        {
            color: '#ffe466ff',
            textShadow: [
                {
                    color: '#000000ff',
                    hidden: false,
                    x: Math.floor(14 * ratio),
                    y: Math.floor(4 * ratio),
                    blur: 2,
                },
            ],
            textGlow: [],
            textBackground: [],
            type: 'local',
            id: 'material_local_1',
            textStroke: [
                {
                    color: '#000000ff',
                    hidden: false,
                    direction: 0,
                    width: Math.ceil(5 * ratio),
                },
            ],
        },
        {
            color: '#ffffffff',
            textShadow: [
                {
                    color: '#000000ff',
                    hidden: false,
                    x: Math.floor(14 * ratio),
                    y: Math.floor(4 * ratio),
                    blur: 2,
                },
            ],
            textGlow: [],
            textBackground: [],
            type: 'local',
            id: 'material_local_2',
            textGradient: {
                colors: [
                    {
                        color: '#ffffffff',
                        value: 0.3963414634146341,
                    },
                    {
                        color: '#ffa9e3ff',
                        value: 1,
                    },
                ],
                angle: 180,
            },
            textStroke: [
                {
                    color: '#000000ff',
                    width: Math.ceil(6 * ratio),
                    direction: 0,
                    hidden: false,
                    editable: true,
                },
            ],
        },
        {
            color: '#ffffffff',
            textShadow: [
                {
                    color: '#00b9b5ff',
                    hidden: false,
                    x: Math.floor(14 * ratio),
                    y: Math.floor(4 * ratio),
                    blur: 2,
                },
            ],
            textGlow: [],
            textBackground: [],
            type: 'local',
            id: 'material_local_3',
            textStroke: [
                {
                    color: '#00b9b5ff',
                    width: Math.ceil(8 * ratio),
                    direction: 0,
                },
            ],
            textGradient: {
                colors: [
                    {
                        color: '#ffffffff',
                        value: 0.5628810975609756,
                    },
                    {
                        color: '#2efcd0ff',
                        value: 0.5628810975609756,
                    },
                ],
                angle: 180,
            },
        },
        {
            color: '#ffffffff',
            textBackground: [],
            type: 'local',
            id: 'material_local_15',
            isVip: true,
            materialID: 'vip-font-style-8',
            textShadow: [
                {
                    color: '#802626ff',
                    hidden: false,
                    x: Math.floor(14 * ratio),
                    y: Math.floor(4 * ratio),
                    blur: 2,
                },
            ],
            textGradient: {
                colors: [
                    {
                        color: '#fff7bfff',
                        value: 0.4104420731707317,
                    },
                    {
                        color: '#ff5f46ff',
                        value: 1,
                    },
                ],
                angle: 180,
            },
            textGlow: [],
            textStroke: [
                {
                    color: '#7e1919ff',
                    hidden: false,
                    direction: 0,
                    width: Math.ceil(6 * ratio),
                },
            ],
        },
        {
            color: '#ffffffff',
            textShadow: [
                {
                    color: '#ffda16ff',
                    hidden: false,
                    x: Math.floor(14 * ratio),
                    y: Math.floor(4 * ratio),
                    blur: 2,
                },
            ],
            textGlow: [],
            textBackground: [],
            type: 'local',
            id: 'material_local_4',
            textStroke: [
                {
                    color: '#ffd105ff',
                    hidden: false,
                    direction: 0,
                    width: Math.ceil(8 * ratio),
                },
            ],
        },
        {
            color: '#51b5ffff',
            textBackground: [],
            type: 'local',
            id: 'material_local_5',
            textShadow: [
                {
                    color: '#51b5ffff',
                    hidden: false,
                    x: Math.floor(13 * ratio),
                    y: Math.floor(4 * ratio),
                    blur: 0,
                },
            ],
            textGlow: [],
            textStroke: [
                {
                    color: '#ffffffff',
                    hidden: false,
                    direction: 0,
                    width: Math.ceil(5 * ratio),
                },
            ],
        },
        {
            color: '#ff83c9ff',
            textBackground: [],
            type: 'local',
            id: 'material_local_6',
            textShadow: [],
            textGlow: [],
            textStroke: [],
            textGradient: {
                colors: [
                    {
                        color: '#5e9cffff',
                        value: 0,
                    },
                    {
                        color: '#0039ff00',
                        value: 0.8616615853658537,
                    },
                ],
                angle: 180,
            },
        },
        {
            color: '#ff5b5bff',
            textBackground: [],
            type: 'local',
            id: 'material_local_7',
            textShadow: [
                {
                    color: '#ff5b5b35',
                    hidden: false,
                    x: Math.floor(14 * ratio),
                    y: Math.floor(14 * ratio),
                    blur: 0,
                },
            ],
            textGlow: [],
            textStroke: [
                {
                    color: '#ffffffff',
                    hidden: false,
                    direction: 0,
                    width: Math.ceil(5 * ratio),
                },
            ],
        },
        {
            color: '#ffffffff',
            isVip: true,
            materialID: 'vip-font-style-3',
            textBackground: [],
            type: 'local',
            id: 'material_local_88888',
            textShadow: [],
            textGlow: [
                {
                    color: '#fd99ffff',
                    hidden: false,
                    width: Math.ceil(38 * ratio),
                },
            ],
            textStroke: [],
        },
        {
            color: '#ffffffff',
            isVip: true,
            materialID: 'vip-font-style-4',
            textBackground: [],
            type: 'local',
            id: 'material_local_8',
            textGlow: [],
            textShadow: [],
            textGradient: {
                colors: [
                    {
                        color: '#ffb0e3ff',
                        value: 0.5365853658536586,
                    },
                    {
                        color: '#ff7bd4ff',
                        value: 0.5426829268292683,
                    },
                ],
                angle: 180,
            },
            textStroke: [
                {
                    color: '#000000ff',
                    hidden: false,
                    direction: 0,
                    width: Math.ceil(8 * ratio),
                },
            ],
        },
        {
            color: '#ffffffff',
            textBackground: [],
            type: 'local',
            isVip: true,
            materialID: 'vip-font-style-2',
            id: 'material_local_9',
            textShadow: [],
            textGlow: [],
            textGradient: {
                colors: [
                    {
                        color: '#ffe283ff',
                        value: 0,
                    },
                    {
                        color: '#ff7532ff',
                        value: 0.6421493902439024,
                    },
                ],
                angle: 0,
            },
            textStroke: [
                {
                    color: '#fff0c4ff',
                    hidden: false,
                    direction: 0,
                    width: Math.ceil(6.8 * ratio),
                },
            ],
        },

        {
            color: '#ffffffff',
            textBackground: [],
            type: 'local',
            id: 'material_local_10',
            textShadow: [
                {
                    color: '#614141d6',
                    hidden: false,
                    x: Math.floor(4 * ratio),
                    y: Math.floor(2 * ratio),
                    blur: Math.ceil(4 * ratio),
                },
            ],
            textGlow: [
                {
                    color: '#fcebbeff',
                    hidden: false,
                    width: Math.ceil(23 * ratio),
                },
            ],
            textGradient: {
                colors: [
                    {
                        color: '#fffde4ff',
                        value: 0,
                    },
                    {
                        color: '#fcebb2ff',
                        value: 0.951219512195122,
                    },
                ],
                angle: 180,
            },
            textStroke: [
                {
                    color: '#998015ff',
                    hidden: false,
                    direction: 0,
                    width: Math.ceil(2 * ratio),
                },
            ],
        },
        {
            color: '#ffffffff',
            textBackground: [],
            type: 'local',
            id: 'material_local_11',
            textShadow: [],
            textGlow: [],
            textGradient: {
                colors: [
                    {
                        color: '#fafcdeff',
                        value: 0.2804878048780488,
                    },
                    {
                        color: '#bdfdecff',
                        value: 0.9634146341463414,
                    },
                ],
                angle: 180,
            },
            textStroke: [
                {
                    color: '#29b680ff',
                    hidden: false,
                    direction: 0,
                    width: Math.ceil(6 * ratio),
                },
            ],
        },
        {
            color: '#ffffffff',
            textBackground: [],
            type: 'local',
            id: 'material_local_12',
            textShadow: [
                {
                    color: '#000000ff',
                    hidden: false,
                    x: Math.floor(14 * ratio),
                    y: Math.floor(5 * ratio),
                    blur: 0,
                },
            ],
            textGlow: [],
            textGradient: {
                colors: [
                    {
                        color: '#fee6d8ff',
                        value: 0.3006859756097561,
                    },
                    {
                        color: '#ff3191ff',
                        value: 0.7641006097560976,
                    },
                ],
                angle: 0,
            },
            textStroke: [
                {
                    color: '#333333ff',
                    hidden: false,
                    direction: 0,
                    width: Math.ceil(8 * ratio),
                },
            ],
        },
        {
            color: '#ffffffff',
            textBackground: [],
            type: 'local',
            id: 'material_local_13',
            textShadow: [],
            textGradient: {
                colors: [
                    {
                        color: '#fffafaff',
                        value: 0.17682926829268295,
                    },
                    {
                        color: '#ffd5e6ff',
                        value: 0.5182926829268293,
                    },
                    {
                        color: '#ff94baff',
                        value: 1,
                    },
                ],
                angle: 0,
            },
            textGlow: [
                {
                    color: '#f29bbab7',
                    hidden: false,
                    width: Math.ceil(26 * ratio),
                },
            ],
            textStroke: [
                {
                    color: '#f183ab99',
                    width: Math.ceil(4 * ratio),
                    direction: 0,
                },
            ],
        },
        {
            color: '#ffffffff',
            textBackground: [],
            type: 'local',
            id: 'material_local_14',
            isVip: true,
            materialID: 'vip-font-style-7',
            textShadow: [
                {
                    color: '#291515ff',
                    hidden: false,
                    x: Math.floor(14 * ratio),
                    y: Math.floor(7 * ratio),
                    blur: 0,
                },
            ],
            textGradient: {
                colors: [
                    {
                        color: '#ffd341ff',
                        value: 0.33727134146341464,
                    },
                    {
                        color: '#fffde4ff',
                        value: 0.5,
                    },
                    {
                        color: '#ffca14ff',
                        value: 0.6604420731707318,
                    },
                ],
                angle: 63,
            },
            textGlow: [],
            textStroke: [
                {
                    color: '#0e0e0eff',
                    hidden: false,
                    direction: 0,
                    width: Math.ceil(10 * ratio),
                },
            ],
        },

        {
            color: '#ffffffff',
            textBackground: [],
            type: 'local',
            id: 'material_local_16',
            textShadow: [
                {
                    color: '#7bbcc2ff',
                    hidden: false,
                    x: Math.floor(15 * ratio),
                    y: Math.floor(4 * ratio),
                    blur: 0,
                },
            ],
            textGradient: {
                colors: [
                    {
                        color: '#ffffffff',
                        value: 0.4104420731707317,
                    },
                    {
                        color: '#b8e5eaff',
                        value: 1,
                    },
                ],
                angle: 180,
            },
            textGlow: [],
            textStroke: [
                {
                    color: '#a3d9dfff',
                    hidden: false,
                    direction: 0,
                    width: Math.ceil(5 * ratio),
                },
            ],
        },
        {
            color: '#f65ea8ff',
            textBackground: [],
            type: 'local',
            id: 'material_local_17',
            textShadow: [
                {
                    color: '#f789bf33',
                    hidden: false,
                    x: Math.floor(20 * ratio),
                    y: Math.floor(3 * ratio),
                    blur: 0,
                },
            ],
            textGlow: [],
            textStroke: [
                {
                    color: '#fce5a4ff',
                    hidden: false,
                    direction: 0,
                    width: Math.ceil(8 * ratio),
                },
            ],
        },
        {
            color: '#ffffffff',
            textBackground: [],
            type: 'local',
            id: 'material_local_18',
            textShadow: [],
            textGradient: {
                colors: [
                    {
                        color: '#ffffffff',
                        value: 0.5606932500953242,
                    },
                    {
                        color: '#92ffb1ff',
                        value: 1,
                    },
                ],
                angle: 178,
            },
            textGlow: [],
            textStroke: [
                {
                    color: '#000000ff',
                    hidden: false,
                    direction: 0,
                    width: Math.ceil(5 * ratio),
                },
                {
                    color: '#ffffffff',
                    hidden: false,
                    direction: 0,
                    width: Math.ceil(4 * ratio),
                },
                {
                    color: '#a7ff5aff',
                    hidden: false,
                    direction: 0,
                    width: Math.ceil(4 * ratio),
                },
            ],
        },
        {
            color: '#ffffffff',
            textBackground: [],
            type: 'local',
            isVip: true,
            materialID: 'vip-font-style-9',
            id: 'material_local_19',
            textShadow: [
                {
                    color: '#000000ff',
                    hidden: false,
                    x: Math.ceil(5 * ratio),
                    y: Math.ceil(1 * ratio),
                    blur: 0,
                },
            ],
            textGlow: [],
            textStroke: [
                {
                    color: '#000000ff',
                    hidden: false,
                    direction: 0,
                    width: Math.ceil(4 * ratio),
                },
                {
                    color: '#abdcffff',
                    hidden: false,
                    direction: 0,
                    width: Math.ceil(9 * ratio),
                },
            ],
        },
    ];

    return presets;
};
